import api from './'

export default {

    /**
     * Get voucher list
     * @param offerId
     */
    getVoucherList(offerId, params) {
        return api
            .get(`/offers/${offerId}/voucherList`, {
                params: params
            })
            .then( response => {
                return response.data
            })
    },

    /**
     * Set voucher list
     * @param offerId
     * @param data
     */
    setVoucherList(offerId, data) {
        return api
            .post(`/offers/${offerId}/voucherList`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Show Offer
     * @param offerId
     * @param params
     */
    show(offerId, params = []) {
        return api
            .get(`/offers/${offerId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update Offer
     * @param offerId
     * @param data
     */
    update(offerId, data) {
        return api
            .put(`/offers/${offerId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete Offer
     * @param offerId
     */
    delete(offerId) {
        return api
            .delete(`/offers/${offerId}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Set calendar
     * @param offerId
     */
    setCalendar(offerId, data) {
        return api
            .post(`/offers/${offerId}/setCalendar`, data)
            .then( response => {
                return response.data
            })
    },

    /**
     * Get payment methods for offer
     * @param offerId
     * @param params
     */
    getPaymentMethodsForOffer(offerId, params = []) {
        return api
            .get(`/offers/${offerId}/paymentMethods`, {
                params: params
            })
            .then(response => {
                return response.data;
            })
    },

    /**
     * Publish Offer
     * @param offerId
     */
    publish(offerId) {
        return api
            .put(`/offers/${offerId}`, {
                published: true
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Unpublish Offer
     * @param offerId
     */
    unpublish(offerId) {
        return api
            .put(`/offers/${offerId}`, {
                published: false
            })
            .then(response => {
                return response.data
            })
    }

}
